/**
 * What an anchored Headless UI panel needs so it does not flash where it has not been placed yet.
 *
 * `anchor` positions a panel with floating-ui, and floating-ui measures *after* mount: the panel is
 * portalled to the end of `document.body` and painted once before its inline `top`/`left` land. That
 * first frame shows the list at the bottom-left of the page, and it then jumps to its trigger —
 * which is the glitch this removes. Starting the panel at `opacity-0` and fading it in over one
 * short transition means the unplaced frame is simply invisible; by the time it has any opacity, it
 * is where it belongs.
 *
 * Use WITH the `transition` prop, which is what makes Headless UI emit `data-closed`/`data-enter`:
 *
 * ```tsx
 * <ListboxOptions transition anchor="bottom start" className={cn(DROPDOWN_PANEL_ANCHOR_CLASSNAME, …)}>
 * ```
 *
 * Only for panels that are actually anchored. One rendered in flow next to its trigger is positioned
 * by layout before it is ever painted and has nothing to hide.
 */
export const DROPDOWN_PANEL_ANCHOR_CLASSNAME =
    'transition duration-100 ease-out data-[closed]:opacity-0 data-[leave]:duration-75';
